// extracted by mini-css-extract-plugin
export default {"buttons":"ContinueButtons_buttons__2vDAL"};